uniform float uTime;
uniform vec3 uBackgroundColor;

varying vec2 vUv;

float random(vec2 st)
{
    return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123);
}

void main()
{
    // Slow breathing effect for cozy feel
    float breathing = sin(uTime * 0.5) * 0.4 + 1.0;
    
    // More visible noise for TV static effect
    vec2 noiseUv = vUv + uTime * 0.1;
    float noiseValue = random(noiseUv * 20.0) * 0.1;
    
    // More pronounced vignette effect
    float centerDistance = distance(vUv, vec2(0.5));
    float vignette = smoothstep(0.6, 0.5, centerDistance);
    vignette *= breathing;
    
    // Subtle background color with more visible noise and vignette
    vec3 color = uBackgroundColor * 0.6;
    color += noiseValue;
    color *= vignette;
    
    gl_FragColor = vec4(color, 1.0);
}